// extracted by css-extract-rspack-plugin
export default {"EmbedPreviewIframe":"biKya","Container":"CFGC3","ResizeHandle":"jYxKJ","Sidebar":"TithD","SidebarContent":"l9iVp","Navigation":"xoc6t","PreviewPanel":"fVdBy"};